var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_vm._v(" "+_vm._s(_vm.category.name)+" "),_c('button',{staticClass:"button red",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeCategory.apply(null, arguments)}}},[_c('img',{staticClass:"minus",attrs:{"src":require("@/assets/minus.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }